export default __webpack_public_path__ + "static/media/paper.5f046948.mp3";